import { render } from "./ClinicView.vue?vue&type=template&id=0f9768ce&scoped=true&ts=true"
import script from "./ClinicView.vue?vue&type=script&lang=ts"
export * from "./ClinicView.vue?vue&type=script&lang=ts"

import "./ClinicView.vue?vue&type=style&index=0&id=0f9768ce&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9768ce"]])

export default __exports__